import {
  NOTIFICATION_PREFERENCE_KEYS,
  type NotificationPreferenceKey,
} from '@/lib/api/domains/notification-preferences';

/*
 * Feature-owned labels for the four GOVERNED notification-preference keys
 * (F02 R25). The keys themselves are the governed registry (AC-09826b9a) and
 * live in the transport (`lib/api/domains/notification-preferences`); this maps
 * each to the human label the portal screen shows. The label is UI text; the
 * key is the governed id that crosses the wire (never free text, AC-09826b9a).
 */
export const NOTIFICATION_PREFERENCE_LABELS: Record<
  NotificationPreferenceKey,
  string
> = {
  payment_due_reminder: 'Payment due reminder',
  auto_debit_approaching: 'Auto-debit approaching',
  auto_debit_posted: 'Auto-debit posted',
  auto_debit_returned_nsf: 'Auto-debit returned (insufficient funds)',
};

/*
 * The four keys in display order (R25). Re-exported from the transport's
 * governed registry so the screen and the registry cannot drift — exactly four
 * (AC-09826b9a).
 */
export const NOTIFICATION_PREFERENCE_ORDER = NOTIFICATION_PREFERENCE_KEYS;
